import { Bound } from "lib/@components/binding/Bound"
import { Alert, Box, CardContent, Stack } from "@mui/material"
import { SummaryDataChanged } from "event-definitions"
import { cloneDeep } from "@apollo/client/utilities"
import { extendSchedule } from "library/extend-schedule.mjs"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { UOM } from "routes/regime/assets/uom"
import { checkPermission } from "library/authorization/index.mjs"
import { ReadonlyUOM } from "./readonly-uom"
import { InventoryCard } from "./inventory-card"

export function Inventory() {
    const { schedule, payload, inDialog, storePayload } = useBoundContext()
    const extendedSchedule = cloneDeep(schedule)
    extendSchedule(extendedSchedule, payload, true)
    const unitsOfMeasurement = Object.keys(
        extendedSchedule.tasks.filter((t) => !t.isHeader).groupBy("unitOfMeasure")
    ).filter((c) => c !== "undefined")
    const refresh = SummaryDataChanged.useRefresh()
    const hasAdvancedTailoring = checkPermission("advancedTailoring")
    const INVENTORY_ALERT_TEXT = `Specify the number of assets associated with this schedule.`

    if (payload.units?.Nr && !unitsOfMeasurement.includes("Nr")) {
        unitsOfMeasurement.push("Nr")
    }

    if (!payload) return null
    payload.units ??= {}

    return (
        <Bound target={payload.units} onChange={storePayload} refresh={refresh}>
            <Box my={2}>
                {inDialog && (
                    <CardContent sx={{ p: inDialog ? 0 : undefined }} data-cy="asset-inventory">
                        <Stack spacing={2}>
                            <Alert severity="info" data-cy="non-synced-schedule-info">
                                {INVENTORY_ALERT_TEXT}
                            </Alert>
                            {unitsOfMeasurement.map((uom) => (
                                <UOM uom={uom} key={uom} />
                            ))}
                        </Stack>
                    </CardContent>
                )}
                {!inDialog && (
                    <InventoryCard
                        sx={{ backgroundColor: "background.neutral" }}
                        contentSx={{ p: inDialog ? 0 : undefined }}
                        isSynced={false}
                    >
                        {hasAdvancedTailoring && (
                            <Alert severity="info" data-cy="non-synced-schedule-info">
                                {INVENTORY_ALERT_TEXT}
                            </Alert>
                        )}
                        {unitsOfMeasurement.map((uom) =>
                            hasAdvancedTailoring ? <UOM uom={uom} key={uom} /> : <ReadonlyUOM uom={uom} key={uom} />
                        )}
                    </InventoryCard>
                )}
            </Box>
        </Bound>
    )
}
